import React from 'react';
import ImageUploader from '../../imageUploader/imageUploader'
import UserActions from 'lib/userActions';
import GA from '../../../lib/ga';

const EVENTS = {
    pagePresented: 'Upload photo page presented',
    imgUploaderPresented: 'Image uploader presented',
    imgUploadingStarted: 'Image uploading started',
    imgUploadedSuccess: 'Image has been uploaded successfully',
    imgUploaderClicked: 'Image uploader clicked',
    imgUploadingFail: 'Image uploading failed'
};

const ImageUploaderWrapper = (props) => {
    const {
        item,
        onSuccess,
        multiple,
        optimizedHeight,
        optimizedWidth,
        onRemoveAll,
        onFailure,
        onBeforeUpload,
        showImages
    } = props;

    const beforeUpload = () => {
        logAction(EVENTS['imgUploadingStarted']);
        if (onBeforeUpload) {
            onBeforeUpload();
        }
    }

    const logAction = message => UserActions.uploadPhoto(message, item.id)

    return  <ImageUploader item={item}
        onPresented={ () => logAction(EVENTS['imgUploaderPresented']) }
        onBeforeUpload={ beforeUpload }
        multiple={ multiple }
        onSuccess={ (res) => {
            onSuccess ? onSuccess(res) : null
            logAction(EVENTS['imgUploadedSuccess'])
        }}
        onRemoveAll={ onRemoveAll }
        onFailure={
            () => {
                logAction(EVENTS['imgUploadingFail']);
                onFailure ? onFailure() : null
            }
        }
        optimizedHeight={ optimizedHeight }
        optimizedWidth={ optimizedWidth }
        onClick={ () => {
            GA.lightListingPhotoUploadedClicked()
            logAction(EVENTS['imgUploaderClicked']) 
            }}
        optionalText={props.optionalText}
        optionalSubText={props.optionalSubText}
        showImages={showImages}
        className={`listing-upload-btn ${props.className}`}/>
};

export default ImageUploaderWrapper;
